{
  "version": 1,
  "asset_id": "5f0434f4-4180-4269-93a8-44b785f74f16",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5f0434f4-4180-4269-93a8-44b785f74f16/loc-houston-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5f0434f4-4180-4269-93a8-44b785f74f16/loc-houston-1280.avif",
  "original_filename": "loc-houston-1280.avif",
  "size": 66396,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:27Z"
}
